var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-list-table',{attrs:{"title":_vm.title,"data-service":_vm.dataService,"headers":_vm.headers,"create-route-name":_vm.createRouteName,"edit-route-name":_vm.editRouteName,"allow-delete":_vm.allowDelete,"show-status-column":_vm.showStatusColumn},scopedSlots:_vm._u([{key:"item.types",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getTypesLabel(item.types))+" ")]}},{key:"item.category",fn:function(ref){
var item = ref.item;
return [(item.category)?[_vm._v(" "+_vm._s(item.category.name)+" ")]:_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }